/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronCompactLeft = createReactComponent(
  "chevron-compact-left",
  "IconChevronCompactLeft",
  [["path", { d: "M13 20l-3 -8l3 -8", key: "svg-0" }]]
);

export { IconChevronCompactLeft as default };
//# sourceMappingURL=IconChevronCompactLeft.js.map
